var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1D428A;}\r\n\t.st1{fill:#C8102E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.4,226.2c-13.1,0-26.5,5.2-33.6,16.2h-0.2h-0.3h0.3l1.3-19c0.8-12.8,3.7-47.7,21.5-47.7 c8.6,0,6.6,11.4,7.6,16.5c2.4,12.1,7.6,25.9,24.2,25.9c11.3,0,23.1-7.5,23.1-22.7c0-23.5-19.7-39-43.6-39 c-61.3,0-86,46.8-86,103.5c0,49.2,19.1,91.7,71.8,91.7c34.2,0,61.9-24.3,61.9-65.2C325.4,251.9,307.1,226.2,277.4,226.2z  M259.2,332.4c-14.6,0-14-18.8-14-40.4c0-21.7,2.1-40.4,14-40.4c14.7,0,15.5,18.7,15.5,40.4C274.7,313.6,271.6,332.4,259.2,332.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.8,155.4v73c40.9,6,89.8,2,124.3-48.5c1.4-2.1,2.3-0.6,1.4,1.2c-9.6,19.6-32.5,37.8-52.2,53.3 c-19,14.9-69.8,68.2-69.1,115.1c0,3.6,0.2,2.6,3.3,0.3c15.4-11.5,45.6-11.8,64.2-2.9c2.6,1.2,2.8,0.8,2.5-2.5 c-3.6-36.4,4.6-76.1,20.2-99.1c10.7-16,39.6-57.1,44.6-89.4c0.5-3.3-1.2-2.8-5.4,1.6c-32.7,34.6-91.9,33.7-130.1-2.9 C76.1,152.3,75,153.4,74.8,155.4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "145.7,44 148.1,51.5 156,51.5 149.5,56.1 151.9,63.5 145.7,59 139.5,63.5 141.8,56.1 135.4,51.5  143.3,51.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "192.3,71.2 194.7,78.6 202.7,78.6 196.2,83.3 198.6,90.6 192.4,86.1 186.1,90.6 188.5,83.3  182,78.6 190,78.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "172.3,50.2 174.7,57.7 182.7,57.7 176.2,62.4 178.6,69.7 172.4,65.1 166.1,69.7 168.5,62.3  162.1,57.7 170,57.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "200,96.9 202.3,104.3 210.3,104.3 203.9,109 206.2,116.3 200,111.8 193.8,116.3 196.2,109  189.7,104.3 197.6,104.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "196.6,124.1 199,131.5 206.9,131.5 200.5,136.2 202.9,143.5 196.6,139 190.5,143.5 192.8,136.1  186.4,131.5 194.3,131.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "181.6,145.7 184,153.2 191.9,153.2 185.5,157.9 187.8,165.2 181.7,160.7 175.4,165.2 177.8,157.9  171.3,153.2 179.3,153.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "158.1,157.9 160.5,165.3 168.3,165.3 161.9,170 164.3,177.3 158.1,172.8 151.9,177.3 154.2,170  147.8,165.3 155.7,165.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98.2,68.8 95.8,76.2 87.9,76.2 94.3,80.9 92,88.2 98.2,83.7 104.5,88.2 102.1,80.9 108.6,76.2  100.6,76.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "117.7,50.2 115.4,57.7 107.4,57.7 113.9,62.4 111.5,69.7 117.7,65.1 124,69.7 121.6,62.3  128.1,57.7 120.1,57.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "89.1,93.6 86.8,101 78.9,101 85.3,105.6 83,113 89.1,108.5 95.4,113 93,105.6 99.5,101 91.6,101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "91.6,120.7 89.2,128.1 81.3,128.1 87.7,132.8 85.4,140.2 91.5,135.6 97.8,140.2 95.4,132.8  101.8,128.1 93.9,128.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "106.5,142.9 104.2,150.3 96.3,150.3 102.7,155 100.3,162.3 106.5,157.8 112.8,162.3 110.4,155  116.9,150.3 108.9,150.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "130.1,156.9 127.8,164.4 119.8,164.4 126.3,169.1 123.9,176.4 130.1,171.9 136.4,176.4 134,169  140.4,164.4 132.5,164.4  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhi);
export default __webpack_public_path__ + "static/media/PHI.77598b6c90797ebedcf3d1a12abddcd8.svg";
export { ForwardRef as ReactComponent };